<script setup>
const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true,
		default: false
	},
	disabled: {
		type: Boolean,
		required: false,
		default: false
	},
	ariaLabel: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
	<label class="toggle-switch" :class="{ 'is-disabled': disabled }" v-bind:aria-label="ariaLabel">
		<input type="checkbox" :checked="modelValue" @change="emit('update:modelValue', $event.target.checked)" :disabled="disabled"/>		
		<span class="slider"></span>
	</label>
</template>

<style scoped>
.toggle-switch {
	position: relative;
	display: inline-block;
	width: 3.25rem;
	height: 1.8125rem;
}

.toggle-switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: var(--toggle-background-Inactive);
	transition: background-color 0.4s;
	border-radius: 1.8125rem;
}

.slider::before {
	content: "";
	position: absolute;
	height: 1.5rem;
	width: 1.5rem;
	left: 0.1875rem;
	top: 0.1875rem;
	background-color: white;
	transition: transform 0.4s;
	border-radius: 50%;
}

input:checked + .slider {
	background-color: var(--toggle-background-Active);
}

input:checked+.slider::before {
	transform: translateX(1.375rem);
}

input:focus-visible + .slider {
	outline-color: var(--border-color-input-Active);
	outline-width: 1.5px;
	outline-style: solid;
	outline-offset: 2px;
}
/* Disabled styling rules */
.is-disabled {
  pointer-events: none; /* Prevents cursor interaction */
}

.is-disabled .slider {
  background-color: var(--toggle-background-Inactive);
  opacity: 0.5;
  cursor: not-allowed;
}

</style>